<div class="about" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <h3>
    {{ "about_title1" | translate }}
    <span> {{ "about_title2" | translate }}</span>
  </h3>
  <p>
    {{ "about_title-content" | translate }}
  </p>

  <div *ngFor="let comp of aboutusComponents">
    <ng-container [ngSwitch]="comp.type">
      <div *ngSwitchCase="'app-circle-text-with-image'">
        <app-circle-text-with-image
          [data]="comp.details"
        ></app-circle-text-with-image>
      </div>
      <div *ngSwitchCase="'app-image-with-circle-text'">
        <app-image-with-circle-text
          [data]="comp.details"
        ></app-image-with-circle-text>
      </div>
      <div *ngSwitchCase="'app-text-with-four-images'">
        <app-text-with-four-images
          [data]="comp.details"
        ></app-text-with-four-images>
      </div>
      <div *ngSwitchCase="'app-four-images-with-text'">
        <app-four-image-with-text
          [data]="comp.details"
        ></app-four-image-with-text>
      </div>
      <div *ngSwitchCase="'app-text-with-one-image'">
        <app-text-with-one-image
          [data]="comp.details"
        ></app-text-with-one-image>
      </div>
      <div *ngSwitchCase="'app-text-with-cover-image'">
        <app-text-with-cover-image
          [data]="comp.details"
        ></app-text-with-cover-image>
      </div>
      <div *ngSwitchCase="'one-image-with-text'">
        <app-one-image-with-text
          [data]="comp.details"
        ></app-one-image-with-text>
      </div>
      <div *ngSwitchCase="'article'">
        <app-articale [data]="comp.details" />
      </div>
      <div *ngSwitchCase="'text-with-images-below'">
        <app-text-with-images-below-component [data]="comp.details" />
      </div>
      <div *ngSwitchCase="'multi-images-with-text'">
        <app-multi-images-with-text [data]="comp"></app-multi-images-with-text>
      </div>
      <div *ngSwitchCase="'clients'">
        <app-our-client
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-our-client>
      </div>
    </ng-container>
  </div>
</div>
